import { Link } from 'react-router-dom';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function SiteLinkFormatter({ info }) {
  const { row } = getInfo(info)
  const { id, name } = row.site || {}

  if (id && name) {
    return <Link className='twy-text-base-accent hover:underline' to={`/admin/sites/${id}`}>
      {`[#${id}] - ${name}`}
    </Link>
  }

  return '--'
}
